import React from 'react';
import PropTypes from 'prop-types';
import SingleSelect from '../../SingleSelect';

export const SimpleOptionSelect = (props) => {
  const { question, value, onChange } = props;

  const handleChange = (id) => (values) => {
    onChange({
      name: id,
      values,
    });
  };

  return (
    <SingleSelect
      id={`${question.id}`}
      key={`${question.id}`}
      placeholder={question.title}
      options={question.options}
      values={value}
      onChange={handleChange(question.id)}
    />
  );
};

SimpleOptionSelect.propTypes = {
  question: PropTypes.object.isRequired,
  value: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
};
